export const handleDrag = (startDragging, event) => {
    event.preventDefault();

    startDragging(true);

    event.stopPropagation();
}

export const handleDragLeave = (stopDraggin, event) => {
    event.preventDefault();

    stopDraggin(false);

    event.stopPropagation();
}

export const handleDrop = (callback, stopDraggin, event) => {
    event.preventDefault();

    const files = event.dataTransfer.files;

    callback(files[0]);
    stopDraggin(false);

    event.dataTransfer.clearData();

    event.stopPropagation();
}